import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Project } from '@app/core/model/entities/project/project';
import { WorkInput } from '@app/core/model/entities/works/work';
import {
  WorkCreateModalComponent
} from '@app/features/main/views/works/works-inventory/modals/work-create-modal/work-create-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './project-work-create-modal.component.html',
  standalone: false
})
export class ProjectWorkCreateModalComponent extends WorkCreateModalComponent implements OnInit {
  private readonly project = inject<{ project: Project }>(MAT_DIALOG_DATA).project;
  public formId: string = 'project_work_creation_dialog';
  private readonly translate = inject(TranslateService);

  /**
   * Initialize missing required fields.
   */
  public ngOnInit(): void {
    super.ngOnInit();
    const defaultMissingRequiredFields = [{code: 'projectId', label: this.translate.instant('LABEL.PROJECT')}]
      .filter(({code}) => !this.accessManager.hasFieldWriteOnCreateAccess(code, EntityTypeEnum.WORK));
    this.missingRequiredFields$ = this.missingRequiredFields$.pipe(
      map(fields => fields.concat(defaultMissingRequiredFields)),
    );
  }

  /**
   * Data from the filled form.
   * @return Work data.
   */
  public getGeneratedObject(): WorkInput {
    const input = super.getGeneratedObject();

    return {
      ...input,
      projectIds: [this.project.id]
    };
  }
}
